<script setup lang="ts">
  import { useNewsStore } from '@/store/News'
  import 'swiper/css'
  import { FreeMode } from 'swiper/modules'
  import { Swiper, SwiperSlide } from 'swiper/vue'
  import { useDisplay } from 'vuetify'
  import { gsap } from 'gsap'

  const { smAndDown: tabletAndMobile } = useDisplay()
  const store = useNewsStore()
  store.fetchAllNews()

  watch(
    () => store.all,
    () => {
      nextTick(() => {
        const tl2 = gsap.timeline({
          scrollTrigger: {
            trigger: '.cloud.rb',
            start: 'top 90%',
            end: '+500 100%',
            scrub: 2,
          },
        })
        tl2.from('.cloud.lb', { x: '-100%' })
        tl2.from('.cloud.rb', { x: '100%' }, '<')
      })
    }
  )
</script>
<template>
  <div v-ga-section-view class="featured-news" data-section-name="Featured News" data-section-number="2">
    <div class="frame">
      <h1 class="lg">Featured News</h1>
      <div v-if="!tabletAndMobile" class="news-list">
        <NewsSummary
          v-for="one in store.featuredHome"
          :key="one.id"
          v-ga-event="{
            interaction: 'link_click',
            sectionContent: one.name,
            newsCategory: one.category,
          }"
          :news="one"
        />
      </div>
      <swiper v-else :direction="'horizontal'" :free-mode="true" :modules="[FreeMode]" :slides-per-view="'auto'">
        <swiper-slide v-for="one in store.featuredHome" :key="one.id">
          <NewsSummary
            v-ga-event="{
              interaction: 'link_click',
              sectionContent: one.name,
              newsCategory: one.category,
            }"
            :news="one"
            :type="'v1'"
          />
        </swiper-slide>
      </swiper>
      <router-link class="view-more-btn" :to="{ name: 'news-list' }">
        <MSButton>View More</MSButton>
      </router-link>
    </div>
    <img v-lazyimage class="cloud lt" fetchpriority="low" src="@/assets/imgs/home/cloud1.webp" />
    <img v-lazyimage class="cloud rt" fetchpriority="low" src="@/assets/imgs/home/cloud1.webp" />
    <img v-lazyimage class="cloud lb" fetchpriority="low" src="@/assets/imgs/home/cloud-left-bottom.webp" />
    <img v-lazyimage class="cloud rb" fetchpriority="low" src="@/assets/imgs/home/cloud1.webp" />
  </div>
</template>

<style lang="scss" scoped>
  .featured-news {
    position: relative;
    z-index: 2;
    height: 714px;
  }
  .frame {
    border-radius: 5px;
    background-color: var(--accent-color2);
    padding: 20px;
    text-align: center;
    h1 {
      color: #4d4136;
      text-align: center;
      // margin-bottom: min(2vw, 20px);
    }
    .news-list {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      grid-gap: var(--default-grid-gap);
    }
    :deep(.swiper) {
      .swiper-wrapper {
        margin: 10px; // for box-shadow
      }
      // height: 500px;
      .swiper-slide {
        width: auto;
        .news-summary {
          width: 50vw;
          margin-right: 10px;
          display: inline-flex;
          & + .news-summary {
            margin-left: 10px;
          }
        }
      }
    }
    .view-more-btn {
      margin: min(2vw, 30px) auto 0;
      display: inline-block;
    }
  }

  .cloud {
    position: absolute;
    z-index: -1;
    height: auto;
    &.lt {
      top: 20%;
      width: 420px;
      left: -20vw;
    }
    &.rt {
      top: 8%;
      width: 380px;
      right: -15vw;
    }
    &.lb {
      width: 380px;
      top: 110%;
      left: -20px;
    }
    &.rb {
      width: 470px;
      top: 95%;
      right: -20px;
      z-index: 4;
    }
  }

  @media #{$contentMaxWidth} {
    .featured-news {
      height: auto;
    }
  }

  @media #{$tablet} {
    .featured-news {
      margin-right: -20px;
      .frame {
        padding: 20px 0 20px 10px;
        border-radius: 5px 0 0 5px;
        border-right: 0;

        h1 {
          // margin-bottom: min(1.5vw - 10px, 20px);
        }
        button {
          margin: 10px auto 0;
        }

        :deep(.swiper) {
          mask-image: linear-gradient(90deg, transparent, black 10px, black calc(100% - 10px));
          .swiper-wrapper {
            margin: 10px 0 10px 10px;
          }
        }
      }
    }
  }

  @media #{$mobile} {
    .featured-news {
      min-height: 435px;
      // margin-right: -10px;
      .frame {
        padding: 20px 0 20px;

        :deep(.swiper) {
          .swiper-slide {
            .news-summary {
              width: 70vw;
            }
          }
        }
      }
    }
  }
</style>
